export default __webpack_public_path__ + "static/media/Hitech-Laser-Logo.39dde53c.webp";